module.exports = __webpack_public_path__ + "files/186f756c011e43cf3dfb9178e3a22d9e.png";